import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import React from 'react'
import { FaCheckDouble } from 'react-icons/fa'
import CustomButton from '../../../shared/CustomButton'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import CheckPermission from '../../../hooks/CheckPermission'
import { useRedoCancelInvoiceMutation } from '../../../redux/api/modules/billingApi'

const RedoCancelInvoice = ({
  setOpenRedoModal,
  refetch,
  setSelectedInvoiceData,
  selectedInvoiceData
}) => {
  const { hasPermission } = CheckPermission()
  const { t } = useTranslation()
  const [redoCancelInvoiceMutation, { isLoading: redoLoading }] = useRedoCancelInvoiceMutation()

  const initialValues = {
    reason: '',
  }
  const validationSchema = Yup.object().shape({
    reason: Yup.string().trim().required('Reason is required'),
  })

  const handleSubmit = async (data) => {
    if (!hasPermission('billing', 'update')) return
    if (!selectedInvoiceData?.invoice_number) return
    try {
      const res = await redoCancelInvoiceMutation({
        invoice_number: selectedInvoiceData?.invoice_number,
        cash_invoice_number: selectedInvoiceData?.cash_invoice_number,
        file_no: selectedInvoiceData?.patient?.file_no,
        reason: data?.reason,
      }).unwrap()

      if (res?.message) {
        toast.success(res?.message)
      } else {
        toast.success(t('Invoice redo successful') || 'Invoice redo successful')
      }
      setSelectedInvoiceData(null)
      setOpenRedoModal(false)
      if (refetch) refetch()
    } catch (error) {
      toast.error(error?.data?.message || error?.message || 'Failed to redo cancel invoice')
    }
  }

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur
        }) => (
          <Form>
            <div className={`flex flex-col gap-1 w-full mb-3 `}>
              <label className='input-label'>{t('Add Reason')}</label>
              <textarea
                placeholder={t('Enter reason')}
                className='w-full p-2 bg-gray-100 rounded-lg border border-gray-300 hover:border-primary !outline-none !shadow-none text-[14px]'
                name='reason'
                onChange={handleChange}
                onBlur={handleBlur}
                rows={3}
              />
              {errors.reason && touched.reason && (
                <span className='text-sm text-red-500'>{errors.reason}</span>
              )}
            </div>
            {hasPermission('billing', 'update') && (
              <div className='flex items-center justify-end'>
                <CustomButton
                  loading={redoLoading}
                  type='submit'
                  icon={<FaCheckDouble size={12} className='me-2' />}
                  label={t('Redo Cancel')}
                  buttonType='primary'
                />
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default RedoCancelInvoice
